import React from 'react';
import { proverbs } from '../data/proverbs';

const PersianIdioms: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto py-12 px-4">
      <h1 className="text-4xl font-bold mb-8 text-center text-orange-400">Persian Idioms & Proverbs</h1>
      <p className="mb-8 text-lg text-orange-200 text-center">
        Explore common Persian idioms and proverbs, their meanings, and examples of how they are used in daily life.
      </p>
      <div className="space-y-8">
        {proverbs.map((proverb) => (
          <div key={proverb.id} className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center mb-2">
              {proverb.icon && <span className="text-2xl mr-2">{proverb.icon}</span>}
              <span className="text-xl font-semibold persian-font" dir="rtl">{proverb.persian}</span>
            </div>
            <div className="text-gray-600 mb-2" dir="ltr">{proverb.transliteration}</div>
            <div className="text-gray-800 font-medium mb-2">{proverb.english}</div>
            {proverb.explanation && (
              <div className="text-gray-700 mb-2"><span className="font-semibold">Meaning:</span> {proverb.explanation}</div>
            )}
            {proverb.example && (
              <div className="text-gray-500 italic border-l-4 border-orange-400 pl-4 mt-2">{proverb.example}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersianIdioms; 